import { FormControl } from '@mui/material';
import { styled } from '@mui/material/styles';

export const FormControlStyled = styled(FormControl, {
  shouldForwardProp: (prop) => prop !== 'isHidden',
})(({ isHidden }) => ({
  display: isHidden && 'none',

  '& .MuiFormControl-root.MuiTextField-root': {
    width: '100%',
  },
}));
